import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const submitCareer = (formData) =>
  axios
    .post(`${API}/careers`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
